<script>
export default {

    name: 'tags-input',

    props: {
        value: null,
        disabled: Boolean,
        readonly: Boolean,
        required: Boolean,
        id: String,
        label: String,
        labelClasses:String,
        labelInline: Boolean,
        placeholder: String,
        icon: String,
        preText: String,
        noRadius: Boolean,
        isMoney: Boolean,
        upperCase: Boolean,
    },

    watch:
    {
        value(val)
        {
            this.internalValue = val
        },

        internalValue(val)
        {
            this.$emit('input', val)
            this.$emit('change')
        },

    },

    methods:
    {
        addTag()
        {
            this.internalValue.push(this.model)
            this.model = null
        },

        removeTag(idx)
        {
            this.internalValue.splice(idx, 1)
        }
    },

    data()
    {
        return {
            internalValue: this.value,
            model: null,
        }
    },

}
</script>

<template>
    <div class="engage-simple-input" :class="{'no-radius': noRadius }">
        <div class="form-group mb-0" :class="{ 'inlineLabel' : labelInline }">
            <label v-if="label" :for="id" :class="labelClasses"> {{ label }} </label>
            <div class="input-group">
                <div v-if="icon" @click="$emit('clickOnIcon')" class="input-group-addon text-center simpleInput" :class="{ 'focus' : hasFocus, 'disabled' : disabled }">
                    <i v-if="icon" :class="'fa fa-' + icon"></i>
                </div>
                <div  v-if="preText" class="pretext d-inline-block py-2 px-2 text-sm esh-light-bgc text-greyish9"
                :class="{ 'disabled' : disabled, 'money': isMoney }" style="width: 84px;">
                    {{ preText }}
                </div>
                <span class="badge badge-primary d-flex my-1 mx-1" style="align-content: center; align-items: center;" v-for="(tag, idx) in internalValue">
                    <strong><u>ID</u>:</strong> {{ tag }}
                    <a class="close ml-2" @click="removeTag(idx)">&times;</a>
                </span>
            </div>
        </div>
        <div class="form-group mb-0">
            <div class="input-group">
                <div  v-if="preText" class="pretext d-inline-block py-2 px-2 text-sm esh-light-bgc text-greyish9"
                    :class="{ 'disabled' : disabled, 'money': isMoney }">
                    Add New
                </div>
                <input
                    type="text"
                    v-model="model"
                    :disabled="disabled"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    :id="id"
                    class="simple"
                    :class="{ 'text-transform-uppercase': upperCase, 'iconed' : icon || preText, 'pl-3 border-radius-2' : !icon && !preText, 'pl-2' : preText }"
                    :required="required"
                >
                <button class="btn btn-success" @click="addTag">+</button>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/TagsInput.vue